<template>
  <div class="screen-3">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <TitleWidget class="text-center">{{ $t(locale.s3.header) }}</TitleWidget>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-sm-6 col-lg-3" v-for="item in screenItems" :key="item.title">
          <div class="screen3-dataitem text-center mt-5">
            <span class="screen-enum-title d-inline-block">{{ $t(item.title) }}</span><br>
            <span class="screen-enum-subtitle d-inline-block mt-3 mt-sm-0 text-sm-center">{{ $t(item.subtitle) }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TitleWidget from "@/components/common/TitleWidget";
import stringsKeys from "@/i18n/strings.json";

export default {
  name: 'ScreenDigits',
  components: {TitleWidget},
  data: () => {
    return {
      locale: stringsKeys,
      screenItems: [
        {title: stringsKeys.s3.market.title, subtitle: stringsKeys.s3.market.subtitle},
        {title: stringsKeys.s3.users.title, subtitle: stringsKeys.s3.users.subtitle},
        {title: stringsKeys.s3.company.title, subtitle: stringsKeys.s3.company.subtitle},
        {title: stringsKeys.s3.age.title, subtitle: stringsKeys.s3.age.subtitle},
      ],
    }
  }
}
</script>

<style lang="scss">
@import "~bootstrap";
@import "src/scss/colors";
@import "src/scss/typo";

.screen-3 {
  background: $white-screen;
  padding-top: 60px;
  padding-bottom: 60px;
  @media (min-width: 992px) {
    background-repeat: no-repeat;
    background-position: right center;
    background-image: url('/img/background-screen-3.svg');
  }
  @media (min-width: 576px) {
    padding-top: 140px;
    padding-bottom: 140px;
  }
}
</style>